
import { GetFavouritesResponse } from '@/api/dtos';
import FavouritesContext from '@/contexts/data/FavouritesContext';
import useGetFavourites from '@/hooks/data/favourites/useGetFavourites';
import { FC, PropsWithChildren } from 'react';


export interface IFavouritesProviderProps {
    initial?: GetFavouritesResponse;
}

export const FavouritesProvider: FC<PropsWithChildren<IFavouritesProviderProps>> = ({ initial, children }) => {
    const favourites = useGetFavourites({ revalidateOnFocus: true, fallbackData: initial});

    return (
        <FavouritesContext.Provider value={favourites}>
            {children}
        </FavouritesContext.Provider>
    );
}

export default FavouritesProvider;
